import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultText, HiddenField } from '@guryou/html-components';
import { dealTokens, SystemCheckbox } from 'components/shared';

const workingDays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

// Same conversion already proven in SessionForm.js/SessionStepTwo.js's own daily-repeat
// day picker: SystemCheckbox is fully controlled (no `name`/`value`), so the "only
// present in the submitted payload when checked" semantics that `name="workingDays"`'s
// native multi-checkbox scraping relied on now come from a HiddenField rendered
// conditionally alongside it, with the same name/value shape. Previously the CheckBox
// was uncontrolled with no onChange at all — technically still clickable only because
// the DOM's own checked state isn't fought by React on every render — so this also adds
// real local state instead of leaving it that way once it's a controlled component.
// Layout: `xs={1.7}` forced all 7 into fixed narrow columns with the label stacked
// below, which is what was truncating the day names — flex-wrap lets each pill size to
// its own label instead of a hard-coded fraction, wrapping to a second row if needed.
const WorkingDays = () => {
  const { t } = useTranslation();
  const [checkedDays, setCheckedDays] = useState(() => workingDays.map((_, index) => index < 5));

  return (
    <>
      <DefaultText fontWeight={800}>{t('SESSIONS.includeDays')}</DefaultText>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: dealTokens.space[4], marginTop: dealTokens.space[3] }}>
        {workingDays.map((day, index) => {
          const checked = checkedDays[index];
          return (
            <React.Fragment key={day}>
              <SystemCheckbox
                label={t(`DAYS.${day}`)}
                checked={checked}
                onChange={next =>
                  setCheckedDays(prev => {
                    const copy = [...prev];
                    copy[index] = next;
                    return copy;
                  })
                }
              />
              {checked && <HiddenField name="workingDays" value={(index + 1) % 7} />}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default WorkingDays;
